var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealth1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8865 13.1486C37.8865 24.4029 19.4164 36.2796 19.4164 36.2796C19.4164 36.2796 0.946289 24.5222 0.946289 13.1486C0.946289 6.8649 5.56768 1.76636 11.2555 1.76636C14.5786 1.76636 17.523 3.48861 19.4087 6.17429C21.1243 3.74439 23.7132 2.09887 26.6499 1.80899C26.9513 1.78341 27.2527 1.76636 27.5618 1.76636C33.1492 1.76636 37.701 6.66028 37.8788 12.7649C37.8865 12.9013 37.8865 13.0121 37.8865 13.1486Z",
    fill: "#E02828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4164 36.2796C19.4164 36.2796 0.946289 24.5222 0.946289 13.1486C0.946289 6.8649 5.56768 1.76636 11.2555 1.76636C14.5786 1.76636 17.5307 3.57296 19.4164 6.25865V36.2796Z",
    fill: "#E96666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.444 6.83772C35.0721 8.63711 36.2696 12.5129 36.4466 14.8435C37.448 11.6551 36.8939 8.1961 34.6489 5.71476C32.6008 3.45119 29.5986 2.50946 26.5986 2.87897C28.2953 3.15005 30.9507 4.08201 33.444 6.83772Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4265 28.5952H17.2744V11.6178H19.4265V28.5952Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5305 28.5952H19.3784V11.6178H21.5305V28.5952Z",
    fill: "#D3E4EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3921 22.2349V17.9786H19.4265V22.2349H11.3921Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3784 22.2349V17.9786H27.4128V22.2349H19.3784Z",
    fill: "#D3E4EF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth1);
export default __webpack_public_path__ + "static/media/health1.cff1090bcb597297b0a75a736561bfeb.svg";
export { ForwardRef as ReactComponent };